import { useField } from 'formik';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  FormattedText as MuiFormattedText,
  FormattedTextProps as MuiFormattedTextProps,
} from '@app/ui/forms/components/FormattedText';

import { useErrorTranslations } from '../../hooks/useErrorTranslations';

export type FormattedTextProps = MuiFormattedTextProps & {
  readonly name: string;
  readonly validation?: (value: any, t?: (key: string, data: { region: string }) => string) => string | undefined;
};

export const FormattedText = memo(({ name, helperText, ...props }: FormattedTextProps) => {
  const { t } = useTranslation('common');
  const [{ value, onChange }, { touched, error }, { setTouched }] = useField({
    name,
    ...(props.validation ? { validate: val => props.validation!(val, t) } : {}),
  });

  const errorHelperText = useErrorTranslations(name, error);

  const isError = Boolean(touched && errorHelperText);

  return (
    <MuiFormattedText
      {...props}
      value={value}
      name={name}
      onChange={onChange}
      onBlurCapture={() => setTouched(true)}
      error={isError}
      helperText={isError ? errorHelperText : helperText || ''}
    />
  );
});
